import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'
import { useResize } from 'stimulus-use'
import { debounce } from "underscore"

import monaco from "../utils/monaco-editor"

export default class extends Controller {
  static targets = ["editor", "mjmlInput", "htmlOutput"]
  static values = { url: String }

  connect() {
    useResize(this);

    this.convert();
    this.loadEditor();

    this.convert = debounce(this.convert, 300);
  }

  async convert() {
    var formData = new FormData();
    formData.append("mjml", this.mjmlInputTarget.value);

    const response = await post(this.urlValue, {
      body: formData,
      responseKind: "json"
    })

    if (response.ok) {
      const json = await response.json
      this.htmlOutputTarget.innerHTML = json.html;
    } else {
      this.htmlOutputTarget.innerHTML = "<p class='text-danger p-3'>Ha fallat la conversió. Si us plau, revisa el codi MJML.</p>";
    }
  }

  loadEditor() {
    //Custom colors
    monaco.editor.setTheme('vs-dark')

    this.editor = monaco.editor.create(this.editorTarget, {
      value: this.mjmlInputTarget.value,
      language: 'html',
      minimap: { enabled: false },
      // fontSize: "15px",
      padding: {
        top: 10
      },
      scrollBeyondLastLine: false,
      // Autocomplete options
      suggest: {
        showWords: false,
        showColumns: false,
        showTables: false,
      },
      wordWrap: 'on',
      wrappingStrategy: 'advanced',
    });

    this.editor.onDidChangeModelContent(() => {
      this.mjmlInputTarget.value = this.editor.getValue();

      // this is debounced, so it won't trigger too often
      this.convert();
    });
  }

  resize() {
    if (this.editor) {
      this.editor.layout();
    }
  }
}
